/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Field_SleepInputs */

const en_us2_search_field_sleep = /** @type {(inputs: Search_Field_SleepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sleep`)
};

const pt_br2_search_field_sleep = /** @type {(inputs: Search_Field_SleepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sono`)
};

const es_419_search_field_sleep = /** @type {(inputs: Search_Field_SleepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sueño`)
};

const pt_pt2_search_field_sleep = /** @type {(inputs: Search_Field_SleepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sono`)
};

const fr_fr2_search_field_sleep = /** @type {(inputs: Search_Field_SleepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sommeil`)
};

const de_de2_search_field_sleep = /** @type {(inputs: Search_Field_SleepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schlaf`)
};

const it_it2_search_field_sleep = /** @type {(inputs: Search_Field_SleepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sonno`)
};

/**
* | output |
* | --- |
* | "Sleep" |
*
* @param {Search_Field_SleepInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const search_field_sleep = /** @type {((inputs?: Search_Field_SleepInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Field_SleepInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_search_field_sleep(inputs)
	if (locale === "es-419") return es_419_search_field_sleep(inputs)
	if (locale === "pt-PT") return pt_pt2_search_field_sleep(inputs)
	if (locale === "fr-FR") return fr_fr2_search_field_sleep(inputs)
	if (locale === "de-DE") return de_de2_search_field_sleep(inputs)
	if (locale === "it-IT") return it_it2_search_field_sleep(inputs)
	return en_us2_search_field_sleep(inputs)
});
export { search_field_sleep as "search.field_sleep" }